<div class="modal-item-actions" [ngClass]="{'-empty': empty}">
    <div class="modal-item-actions__inner">
        <ng-container *ngIf="!empty">
            <ng-template #left>

                <div class="modal-item-actions__col -left" [ngClass]="{'-not-visible': !isQuantityVisible}">

                    <shared-quantity *ngIf="isQuantityVisible" class="modal-item-actions__elem -for-quantity"
                        [max]="max" [disabled]="disabled" [size]="size" [quantity]="quantity" mode="compact"
                        [minimumHide]="minimumHide" [remove]="remove" (onIncrement)="handleIncrement($event)"
                        (onDecrement)="handleDecrement($event)" (onRemove)="handleRemove($event)"></shared-quantity>

                </div>





            </ng-template>

            <ng-template #right>
                <div class="modal-item-actions__col -right" *ngIf="isCtaVisible">

                    <shared-btn [disabled]="disabled" [size]="size" class="modal-item-actions__elem -for-cta"
                        (onClick)="handleCtaClick($event)" [width]="'extended'">
                        {{buttonLabel}}
                        <ng-container *ngIf="buttonPrice !== null && buttonPrice !== undefined"> -
                            {{buttonPrice | currency : config.localization.currency:'symbol-narrow':null: config.localization.locale}}
                        </ng-container>
                    </shared-btn>

                </div>
            </ng-template>

            <shared-two-columns [mobileLeft]="twoColumnsMobileLeft" [mobileRight]="twoColumnsMobileRight" [left]="left"
                [right]="right" [marginBottom]="twoColumnsMarginBottom" [adjust]="twoColumnsAdjust"
                [align]="twoColumnsAlign">
            </shared-two-columns>
        </ng-container>
    </div>
</div>
